module.exports = __webpack_public_path__ + "static/media/horizontal-logo.05e3f5df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/assets/logos/genesisbm/horizontal-logo.svg
// module id = 750
// module chunks = 0